import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  inject,
  Injector,
  input,
  viewChild,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { FormField } from '@shared/classes';
import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';
import { TrimInputDirective } from '@shared/directives';
import { Dict, Tooltip, Undefined } from '@shared/models';

import { FieldErrorsComponent } from '../field-errors/field-errors.component';

@Component({
  selector: 'b2c-input',
  styleUrl: './input.component.scss',
  templateUrl: './input.component.html',
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
    },
  ],
  imports: [
    FormsModule,
    TooltipComponent,
    TrimInputDirective,
    FieldErrorsComponent,
  ],
})
export class InputComponent extends FormField implements AfterViewInit {
  label = input<string>('');
  ariaLabel = input<string>(''); // accessible name when no visible label is used
  type = input<string>('text');
  inputMode = input<string>('text');
  minLength = input<number>(0);
  labelStyles = input<Dict>({});
  errorStyles = input<Dict>({});
  labelGroup = input<string>('');
  placeholder = input<string>('');
  autoComplete = input<string>('');
  maxLength = input<number>(52100);
  pattern = input<string>('');
  numericOnly = input<boolean>(false);
  trim = input<boolean>(true);
  required = input<boolean>(false);
  autoFocus = input<boolean>(false);
  id = input<number>(Math.random());
  inputTypeGroup = input<boolean>(false);
  serverErrorMessage = input<string>('');
  tooltip = input<Undefined<Tooltip>>(undefined);
  errorMessages = input<Record<string, string>>({});

  input = viewChild.required<ElementRef<HTMLInputElement>>('input');

  private readonly injector: Injector = inject(Injector);

  ngAfterViewInit(): void {
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    }

    // Set focus on input
    if (this.autoFocus()) {
      this.input().nativeElement.focus();
    }
  }

  onInput(event: Event): void {
    const eventTarget = event.target as HTMLInputElement;
    const rawValue = eventTarget.value || '';
    let value = rawValue;

    if (this.numericOnly()) {
      value = rawValue.replace(/\D/g, '');
    } else if (this.trim()) {
      value = rawValue.trim();
    }

    eventTarget.value = value;

    this.control.setValue(value, {
      emitEvent: false,
      emitModelToViewChange: true,
    });
  }
}
